import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import * as invoiceActions from '../../../redux/invoices/actions';
import Spin from '../../../components/loading';

function AdditionalDetails(props) {
  const { error, loading, message, failed } = props;

  const close = e => {
    e.preventDefault();

    props.close();
  };

  return (
    <Modal size="xl" isOpen={this.props.isOpen}>
      <ModalHeader>
        <div className="row">
          <div className="col-11">{locales('titles.financial.transaction.details')}</div>
          <div className="col-1 text-left">
            <a href="#" onClick={close}>
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <Spin spinning={loading}>
          {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {failed && <div className="alert alert-danger">{message}</div>}
        </Spin>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-success" onClick={close}>
          {locales('tables.close')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    toggleStatus: (id, isActive) =>
      dispatch(invoiceActions.toggleStatus(id, isActive))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalDetails);
